import { compareIso, nowDate } from "../../dateUtils";
import { CustomerShipmentListItem } from "../../fms.data/models/CustomerShipmentListItem";
import { ReportScheduleListItem } from "../../fms.data/models/ReportScheduleListItem";

export enum shipmentStatus{
  NotDeparted,
  VesselDeparture,
  VesselArrival,
  PickupAvailable,
  GateOut,
  EmptyCntrReturn,
}


//List Line Background Color (List와 Export to Excel시 표시되는 Color)
export  const customerShipmentStatus = [
  {color: 'FFFFFF', label : 'NOT DEPARTED'},
  {color: 'F9DFF3', label : 'VESSEL DEPARTURE'},
  {color: 'C8BFE7', label : 'VESSEL ARRIVAL'},
  {color: '71DAFF', label : 'PICKUP AVAILABLE'},
  {color: 'A9F3A3', label : 'GATE OUT'},
  {color: 'A7A7A7', label : 'EMPTY CNTR RETURN'},
]

//List Info Background Color (Side Menu, Shipment Status Combo Box에 표시되는 color)
export  const customerShipmentInfoStatus = [
  {color: 'FFFFFF', label : 'NOT DEPARTED'},
  {color: 'FFAEC9', label : 'VESSEL DEPARTURE'},
  {color: 'C8BFE7', label : 'VESSEL ARRIVAL'},
  {color: '00A2E8', label : 'PICKUP AVAILABLE'},
  {color: 'B5E61D', label : 'GATE OUT'},
  {color: '7F7F7F', label : 'EMPTY CNTR RETURN'},
]

export const trackEvent1 = ['empty out', 'full in', 'vessel loaded'];
export const trackEvent2 = ['vessel departed', 'transshipment arrived', 'transshipment discharged', 'transshipment loaded','transshipment departed', 'eta change'];
export const trackEvent3 = ['vessel arrived','vessel berthed','vessel discharged','holds at pod terminal','pod terminal changed','pod terminal','pickup lfd','pickup appointment at' ,'available for pickup'];
export const trackEvent4 = ['full out'];
export const trackEvent5 = ['empty in'];

export function StatusBackColor(data: CustomerShipmentListItem){
  const l = data;
  let color = '';
  let status = undefined;

    if(l.trId){   //Tracking 실행된 경우
      if(l.ord || l.inGateDate || l.loadedDate){
        status = shipmentStatus.NotDeparted;
      }
      if(l.vesselDepartureDate) {
        status = shipmentStatus.VesselDeparture;
      }
      if(l.vesselArrivalDate || l.unloadedDate) {
        status = shipmentStatus.VesselArrival;
      }
      if(l.lastFreeDay || l.pickupAvailableDate) {
        status = shipmentStatus.PickupAvailable;
      }
      if(l.pickupContainerDate){
        status = shipmentStatus.GateOut
      }
      if(l.emptyReturnDate){
        status = shipmentStatus.EmptyCntrReturn;
      }
      if(!l.ord && !l.inGateDate && !l.loadedDate && !l.vesselDepartureDate && !l.vesselArrivalDate && !l.unloadedDate && !l.pickupAvailableDate && !l.pickupContainerDate && !l.actualDeliveryDate && !l.emptyReturnDate){
         status = shipmentStatus.NotDeparted;
      }
  } else if(!l.trId){   //Tracking 실행되지 않은 경우
      if(l.ord || l.inGateDate || l.loadedDate){
        status = shipmentStatus.NotDeparted;
      }
      if(l.vesselDepartureDate) {
        status = shipmentStatus.VesselDeparture;
      }
      if(l.vesselArrivalDate || l.unloadedDate) {
        status = shipmentStatus.VesselArrival;
      }
      if(l.lastFreeDay || l.pickupAvailableDate){
        status = shipmentStatus.PickupAvailable;
      }
      if(l.pickupContainerDate) {
        status = shipmentStatus.GateOut;
      }
      if(l.emptyReturnDate){
        status = shipmentStatus.EmptyCntrReturn;
      }
  }

  if (status !== undefined ) color = `#${customerShipmentStatus[status].color}`;
  
  return color;
}

export function ExportStatusBackColor(accessor: string, value: any){
  const ord = value['ord'];
  const inGateDate = value['inGateDate'];
  const loadedDate = value['loadedDate'];
  const vesselDepartureDate = value['vesselDepartureDate'];
  const vesselArrivalDate  = value['vesselArrivalDate'];
  const unloadedDate = value['unloadedDate'];
  const pickupAvailableDate = value['pickupAvailableDate'];
  const pickupContainerDate = value['pickupContainerDate'];
  const actualDeliveryDate = value['actualDeliveryDate'];
  const emptyReturnDate = value['emptyReturnDate']; 
  const lfd = value['lastFreeDay']
  const trId = value['trId'];


  let status = undefined;
  let color = 'none';
    if(trId){   //Tracking 실행되지 않은 경우
      if(ord || inGateDate || loadedDate){
        status = shipmentStatus.NotDeparted;
      }
      if(vesselDepartureDate) {
        status = shipmentStatus.VesselDeparture;
      }
      if(vesselArrivalDate || unloadedDate) {
        status = shipmentStatus.VesselArrival;
      }
      if(lfd || pickupAvailableDate) {
        status = shipmentStatus.PickupAvailable;
      }
      if(pickupContainerDate){
        status = shipmentStatus.GateOut;
      }
      if(emptyReturnDate){
        status = shipmentStatus.EmptyCntrReturn;
      }
      if(!ord && !inGateDate && !loadedDate && !vesselDepartureDate && !vesselArrivalDate && !unloadedDate && !pickupAvailableDate && !pickupContainerDate && !actualDeliveryDate && !emptyReturnDate){
         status = shipmentStatus.NotDeparted;
      }
  } else if(!trId){  //Tracking 실행되지 않은 경우
      if(ord || inGateDate || loadedDate){
        status = shipmentStatus.NotDeparted;
      }
      if(vesselDepartureDate) {
        status = shipmentStatus.VesselDeparture;
      }
      if(vesselArrivalDate || unloadedDate ) {
        status = shipmentStatus.VesselArrival;
      }
      if(lfd || pickupAvailableDate) {
        status = shipmentStatus.PickupAvailable;
      }
      if(pickupContainerDate){
        status = shipmentStatus.GateOut;
      }
      if(emptyReturnDate){
        status = shipmentStatus.EmptyCntrReturn;
      }
  }

  if (status !== undefined) color = customerShipmentStatus[status].color;
  
  return color;
}


export function SchBackColor(data: ReportScheduleListItem){
  const l = data;
  let color = '';
  if (l.isPaused) {
    color = "#e7e7e7";
  }
  if(compareIso(l.endDate??'', nowDate()) < 0){
    color = "#969696";
  }
  return color;
}

